import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ApiService } from 'src/app/services/api.service';
import { AppSettings } from 'src/app/services/AppSettings';
import { GigsumoService } from 'src/app/services/gigsumoService';
import { UtilService } from 'src/app/services/util.service';
import { DropdownManagerService } from 'src/app/services/dropdown-manager.service';
import { BusinessCard } from 'src/app/types/BusinessCard';
import { ContractService } from 'src/app/services/contract.service';
import { B2bDocumentSetupComponent } from '../../shared/b2b-document-setup/b2b-document-setup.component';
import Swal from 'sweetalert2';
import { CustomerService } from '../../bussinesspages/user-management/customer-service.service';
import { PricePlanService } from '../../Price-subscritions/priceplanService';
import { CommonModalComponent } from '../../bussinesspages/user-management/common-modal/common-modal.component';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';

declare var $: any;

@Component({
  selector: 'app-b2bnetwork-card',
  standalone: true,
  imports: [BsDropdownModule, CommonModule,
CommonModalComponent,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './b2bnetwork-card.component.html',
  styleUrls: ['./b2bnetwork-card.component.scss']
})

export class B2BNetworkcardComponent {
  url= AppSettings.photoUrl

  role:any
  @Input()
  businessDetails: any;
  @Input()
  From: string = "";
  constructor(
    private util: UtilService,
    private api: ApiService,
    private router: Router,
    private customerService : CustomerService,
    private pricePlanService : PricePlanService,
    private modalService: BsModalService,
    private contractService: ContractService,
    private dropdownManager: DropdownManagerService,
  ) {
  }
  @Input()
  BusinessDataInput: BusinessCard;
  @Output() updateNetworkList = new EventEmitter<{ value: any, action: string }>();
  combinedBusinessDetails: any;
  userId=localStorage.getItem('userId');
  dropdownId: string = `b2b-dropdown-${Math.random().toString(36).substr(2, 9)}`;

  ngOnInit() {
    this.updateCombinedBusinessDetails();
    // Subscribe to dropdown state changes
    this.dropdownManager.dropdownState$.subscribe(currentDropdownId => {
      if (currentDropdownId && currentDropdownId !== this.dropdownId) {
        // Another dropdown was opened, close this one
        this.closeDropdown();
      }
    });
  }

  onDropdownToggle(isOpen: boolean) {
    if (isOpen) {
      this.dropdownManager.openDropdown(this.dropdownId);
    } else {
      this.dropdownManager.closeDropdown();
    }
  }

  closeDropdown() {
    // This will be called to programmatically close the dropdown
    $(`#${this.dropdownId}`).removeClass('open');
  }
  // ngOnChanges() {
  //   this.updateCombinedBusinessDetails();
  // }
  updateCombinedBusinessDetails() {
    this.combinedBusinessDetails = {
      ...this.businessDetails,
      contactBusinessId: this.BusinessDataInput?.businessId
    };
  }

  b2bnetworkcarddata:any
  sendMessage(user: BusinessCard) {

    var userData: any = {};
    userData.type = "BUSINESS";
    userData .refererId= user.businessId
    this.router.navigate(["message"], { queryParams: userData });
  }



  businessprofile(val){

    if (val.businessId != undefined) {
      localStorage.setItem("businessId", val.businessId);
      var data: any = {};
      data.businessId = val.businessId;
      data.businessName = val.businessName;
      data.businessEmail = val.businessEmail;
      data.isEmployee = val.employee;
      data.isFollower = val.followed;
      data.isAdmin = val.businessAdmin;
      data.isSuperAdmin = val.superAdmin;
      data.b2bcardroute=true;
      this.router.navigate(["/business/post"], { queryParams: data });
    }

}
  showModal: boolean = false;
  selectedItem: string = 'businessContacts';

  closeModal(data?) {
    this.showModal = false;
    this.modalService.hide(this.modalService.getModalsCount());
  }

  async opencontactmodal(id){
    this.util.startLoader();
    const businessPLan = await this.customerService.getBusinessPLanBenefits(id , "B2B_CONTACTS");

    if(businessPLan.available > 0){
      this.showModal = true;
    }
    else{
      this.pricePlanService.expiredPopup(
        "B2B_CONTACTS",
        "PAY",
        null,
        null,
        null,
        null,
        businessPLan.available,
        businessPLan.actual,
        businessPLan.utilized,
        businessPLan.promotional
      );
    }

    this.util.stopLoader();


  }

  handleInvite(value: any, action: 'REJECT' | 'CANCEL') {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: { confirmButton: 'btn btn-success', cancelButton: 'btn btn-danger' },
      buttonsStyling: false
    })
    let contactStatus: string;
    let successMessage: string;

    switch (action) {
      case 'REJECT':
        contactStatus = "REJECTED";
        successMessage = "Contact request rejected";

        swalWithBootstrapButtons.fire({
          title: `Are you sure you want to reject ${value.businessName}?`,
          icon: 'warning',
          showCancelButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          reverseButtons: true
        }).then((result) => {
          if (result.isConfirmed) {
            this.processInvite(value, contactStatus, successMessage, action);
          }
        });
        break;

      case 'CANCEL':
        contactStatus = "CANCELLED";
        successMessage = "Contact request cancelled";
        this.processInvite(value, contactStatus, successMessage, action);
        break;

      default:
        contactStatus = "";
        successMessage = "";
    }
  }

  processInvite(value: any, contactStatus: string, successMessage: string, action: string) {
    const data = {
      businessId: this.businessDetails.id,
        peerBusinessId: value.businessId,
        contactStatus: contactStatus,
    };

    this.util.startLoader();
    this.api.create("business/updateB2BContact", data).subscribe(
      (res) => {
        this.util.stopLoader();
        if (res.code == "00000") {
          Swal.fire({
            icon: "success",
            title: successMessage,
            showConfirmButton: false,
            timer: 2000,
          }).then(() => {
            this.updateNetworkList.emit({ value: null, action: 'accept' });
          });

          // Show B2B document setup modal on accept, then chain assign employees swal for customer
          if (contactStatus === 'CONNECTED') {
            const myBusinessId = this.businessDetails.id;
            const peerBusinessId = value.businessId;
            const mode = (value.peerContactType === 'Supplier' || value.contactType === 'Supplier') ? 'customer' : 'supplier';
            this.contractService.getB2BContact(myBusinessId, peerBusinessId).subscribe((b2bRes: any) => {
              const b2bContactId = b2bRes?.data?.b2bContact?.b2bContactId;
              if (b2bContactId) {
                this.modalService.show(B2bDocumentSetupComponent, {
                  initialState: {
                    b2bContactId,
                    myBusinessId,
                    peerBusinessId,
                    peerBusinessName: value.businessName,
                    mode
                  },
                  class: 'modal-lg',
                  backdrop: 'static',
                  keyboard: false
                });
                if (mode === 'customer') {
                  const swalWithBootstrapButtons = Swal.mixin({
                    customClass: { confirmButton: 'btn btn-success' },
                    buttonsStyling: false
                  });
                  const onHiddenSub = this.modalService.onHidden.subscribe(() => {
                    onHiddenSub.unsubscribe();
                    swalWithBootstrapButtons.fire({
                      title: 'Assign Business Employees',
                      text: 'Now that you have connected to the business contact. Please, map your employees that you want to work with this business.',
                      icon: 'question',
                      confirmButtonText: 'OK',
                      allowOutsideClick: false,
                      allowEscapeKey: false,
                      reverseButtons: true,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        this.router.navigate(['/user-management/businessContacts/businessConnectEdit'], {
                          queryParams: { id: myBusinessId, contactBusinessId: peerBusinessId }
                        });
                      }
                    });
                  });
                }
              }
            });
          }
        } else {
          Swal.fire({
            icon: "info",
            title: "Oops...",
            text:
              action === 'REJECT'
                ? "Contact reject request failed. Please try after a while."
                : "Something went wrong. Please try after some time.",
            showConfirmButton: false,
            timer: 4000,
          });
        }
      },
      (error) => {
        this.util.stopLoader();
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Something went wrong. Please try again later.",
          showConfirmButton: false,
          timer: 4000,
        });
      }
    );
  }

  removeUserContact(value: any) {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: { confirmButton: 'btn btn-success', cancelButton: 'btn btn-danger' },
      buttonsStyling: false
    })
    swalWithBootstrapButtons.fire({
      title: `Are you sure you want to remove ${value.businessName}?`,
      icon: 'warning',
      showCancelButton: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        this.util.startLoader();
        this.api.delete(`business/removeB2BContact/${this.businessDetails.id}/${value.businessId}`).subscribe(
          (res) => {
            this.util.stopLoader();
            if (res.code === '00000') {
              Swal.fire({
                icon: 'success',
                title: 'Contact removed successfully',
                showConfirmButton: false,
                timer: 2000,
              }).then(() => {
                this.updateNetworkList.emit({ value: null, action: 'remove' });
              });
            }
          },
          (error) => {
            this.util.stopLoader();
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Something went wrong. Please try again later.',
              showConfirmButton: false,
              timer: 4000,
            });
          }
        );
      }
    });
  }
  removememberContact(businessId) {
    this.util.startLoader();
    this.api.delete(`business/removeBusinessUsersContact/${businessId}/${this.userId}`).subscribe(
      (res) => {
        this.util.stopLoader();
        if (res.code === '00000') {
          Swal.fire({
            icon: 'success',
            title: 'Contact removed successfully',
            showConfirmButton: false,
            timer: 2000,
          }).then(() => {
            this.updateNetworkList.emit({ value: null, action: 'remove' });
          });
        }
      },
      (error) => {
        this.util.stopLoader();
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Something went wrong. Please try again later.',
          showConfirmButton: false,
          timer: 4000,
        });
      }
    );
  }

  connectionrequest(value, action: 'ACCEPT' | 'REJECT') {

      const data = {
        userId: localStorage.getItem("userId"),
        businessId: value.businessId,
        status: action === 'ACCEPT' ? "CONNECTED" : "REJECTED",
      };

      const successMessage = action === 'ACCEPT'
        ? "Request accepted successfully"
        : "Connection request rejected";

      this.util.startLoader();
      this.api.updatePut("business/updateBusinessUsersContact", data).subscribe(
        (res) => {
          this.util.stopLoader();
          if (res.code == "00000") {
            Swal.fire({
              icon: "success",
              title: successMessage,
              showConfirmButton: false,
              timer: 2000,
            }).then(() => {
              this.updateNetworkList.emit({ value: null, action: 'accept' });
            });
          } else {
            Swal.fire({
              icon: "info",
              title: "Oops...",
              text: action === 'ACCEPT'
                ? "Connection accept request failed. Please try after a while."
                : "Something went wrong. Please try after some time",
              showConfirmButton: false,
              timer: 4000,
            });
          }
        },
        (error) => {
          this.util.stopLoader();
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Something went wrong. Please try again later.",
            showConfirmButton: false,
            timer: 4000,
          });
        }
      );
    }


}


